import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';
import '~/assets/css/fitness-globals.scss';
import ProfileForm from '~/components/ProfileForm';
import FormDatepicker from '~/components/ProfileForm/FormDatePicker';
import FormDropdown from '~/components/ProfileForm/FormDropdown';
import InterestCarousel from '~/components/ProfileForm/InterestCarousel';

class SetupProfile extends React.Component {

	constructor(props){
		super(props);
		this.state = {loading: false};

		this.handleClose = this.handleClose.bind(this);
	}

	handleSubmit(e){
		e.preventDefault(); 
		this.props.save().then(res => {
			this.setState({loading: false});
			this.props.onClose();
		});
		this.setState({loading: true});
	}

	handleClose(){
		this.props.saveEmpty();
		this.props.onClose();
	}

	renderForm(){
		const profile = this.props.profile.data.main;
		return 	(
			<form onSubmit={this.handleSubmit.bind(this)} className="profileForm">
		    	<input
		    		type="text"
					onChange={this.props.updateInput}
					onEmptyField={this.props.emptyField}
					name="name"
					label="First Name"
					placeholder="First Name"
					value={profile.name}
					error={this.props.errors.name}
                />
               <input
               		type="text"
					onChange={this.props.updateInput}
					onEmptyField={this.props.emptyField}
					name="lastName"
					label="Last Name"
					placeholder="Last Name"
					value={profile.lastName}
					error={this.props.errors.lastName}
                />
                <div className="input-line">
	                <FormDropdown
						onChange={this.props.updateField}
						name="gender"
						label="Gender"
						placeholder="Gender"
						list={["FEMALE", "MALE", "OTHER", "PREFER NOT TO SAY"]}
						value={profile.gender}
						error={this.props.errors.gender}
	                />
	                <FormDatepicker
						onChange={this.props.updateDOB}
						label="Birthday"
						placeholder="Birthday"
						onEmptyField={this.props.emptyField}
						name="DOB"
						value={profile.DOB || ""}
						error={this.props.errors.DOB}
	                />
	            </div>
                {this.props.questions.map((question, key) => {
					const q = this.props.findQuestion(question.question, profile.questions);
					return (
						<FormDropdown
							key={key}
							name={question.question}
							placeholder={question.question}
							onChange={this.props.updateQuestion}
							label={question.question}
							list={question.answers}
							value={q.answer}
	                    />
					);
                })}
                <InterestCarousel 
                	interests={this.props.interests}
                	selectedInterests={profile.interests}
                	onSelect={this.props.toggleInterest}
                />
                <hr/>
	          	<input
	          		type="submit"
	          		className="primary-button black"
	            	disabled={this.props.saving}
	            	value={this.props.saving ? "Saving" : "Save"}
	          	/>	     
	        </form>
		);
	}

	render() {
		return (
			<div className="setup-profile fitness-modal">
				<div className="close-button" onClick={this.handleClose}><i className="ion-ios-close-empty"/></div>
				<h3>WELCOME TO NEOU</h3>
				<h2>Set Up Your Profile</h2>
				<p>
					We aim to help you discover the best workouts to match your fitness goals and abilities. 
					See our <a href="/privacy-policy">privacy policy</a> for complete details.
				</p>
				{this.props.profile && this.renderForm()}
			</div>
		);
	}

}

SetupProfile.propTypes = {
  onClose: PropTypes.func,
  save: PropTypes.func,
  saveEmpty: PropTypes.func,
  findQuestion: PropTypes.func,
  updateField: PropTypes.func,
  updateInput: PropTypes.func,
  updateQuestion: PropTypes.func,
  profile: PropTypes.object,
  questions: PropTypes.array,
  saving: PropTypes.bool,
  toggleInterest: PropTypes.func,
  errors: PropTypes.object
};

export default ProfileForm(SetupProfile);